import axios, { AxiosResponse } from 'axios';
import { con } from '../../../application/entity/Rutas';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

export class SVCDocumentos {

    public static async ObtieneListadoDocumentos(headers: any,codigoCarrera: string, codigoNegocio: number, rut: number, sistema: string, codigoPlanificacion: number, idPeriodo: number, idPersona: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "GetDocumentosPorAlumnoYCarrera";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                headers,
                params: {
                    "rut": rut,
                    "codNegocio": codigoNegocio,
                    "codCarrera": codigoCarrera,
                    "sistema": sistema,
                    "codigoPlanificacion": codigoNegocio === 1 ? 0 : codigoPlanificacion,
                    "idPeriodo": idPeriodo,
                    "idPersona": idPersona
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async InsertarDocumentos(tipo: number, rut: number, codigoCarrera: string, sistema: string, idDocumento: number, extension: string, base64: string, anio: number, periodo: number, codNegocio: number, codigoPlanificacion: number, idPeriodo: number, idPersona: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GuardarAlumnoDocumento/saveDocumento";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                "tipo": tipo,
                "rut": rut,
                "codigoPrograma": codigoCarrera,
                "sistema": sistema,
                "idDocumento": idDocumento,
                "extension": extension,
                "base64": base64,
                "codNegocio": codNegocio,
                "anio": anio,
                "periodo": periodo,
                "codigoPlanificacion": codNegocio === 1 ? 0 : codigoPlanificacion,
                "idPeriodo": idPeriodo,
                "idPersona": idPersona
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async EliminarDocumentos(/* tipo: number, */ rut: number, codigoCarrera: string, /* sistema: string, */ idDocumento: number, anio: number, periodo: number/* , extension: string, base64: string, anio: number, periodo: number */): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Documento/deleteDocumentos";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                params: {
                    "rut": rut,
                    "codCarrera": codigoCarrera,
                    "idDocumento": idDocumento,
                    "anio": anio,
                    "periodo": periodo
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;

    }
}